import { render, staticRenderFns } from "./FicoSignViolationsDriverPivot.vue?vue&type=template&id=5e617b6c&"
import script from "./FicoSignViolationsDriverPivot.vue?vue&type=script&lang=js&"
export * from "./FicoSignViolationsDriverPivot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports